import React from "react";
import { useSelector } from "react-redux";
import { getImageProduct } from "../../shared/ultils";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  deleteItemCart,
  updateCart,
  resetCart,
} from "../../redux-setup/reducers/cart";
import { createOrder } from "../../services/Api";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const itemsCart = useSelector(({ cart }) => cart.items);
  const login = useSelector(({ auth }) => auth.login);
  const newItems = itemsCart.map(
    (item) => ({ prd_id: item._id, price: item.price, qty: item.qty }) //=>() vì ES6 ko cho phép return Obj {} nên đánh lừa nó return biểu thức, trong biểu thức có chứa Obj: cú pháp
  );
  const totalPrice = itemsCart?.reduce(
    (total, item) => total + item.qty * item.price,
    0
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clickOrder = (e) => {
    e.preventDefault(); //do bấm vào thẻ <a>, dùng <Link> thì ko bị
    const { _id, fullName, email, address, phone } = login.currentCustomer;
    createOrder({
      fullName,
      email,
      address,
      phone,
      customer_id: _id,
      totalPrice: totalPrice,
      items: newItems,
    })
      .then(() => {
        //xoá giỏ hàng trong Reducer
        dispatch(resetCart());
        //chuyển hướng đến trang thông báo đặt hàng thành công
        return navigate("/Success");
      })
      .catch((error) => console.log(error));
  };
  const onChangeQty = (e, id) => {
    const value = Number(e.target.value);
    //kiểm tra value nếu về 0 thì xoá sản phẩm
    if (value === 0) {
      // eslint-disable-next-line no-restricted-globals
      const isConfirm = confirm("Bạn có chắc chắn muốn xoá?"); //yes=true
      return isConfirm
        ? dispatch(
            deleteItemCart({
              // {} chính là payload
              _id: id,
            })
          )
        : false;
    }
    dispatch(
      updateCart({
        _id: id,
        qty: value,
      })
    );
  };
  const clickDeleteItemCart = (e, id) => {
    //do xử lý trên thẻ <a> nên cần ngăn nhảy lên đầu trang (liên kết đánh dấu)
    e.preventDefault();
    // eslint-disable-next-line no-restricted-globals
    const isConfirm = confirm("Bạn có chắc chắn muốn xoá?"); //yes=true
    //Cach 1:
    // if (isConfirm){
    //     dispatch(deleteItemCart({
    //         _id: id,
    //     }));
    // };
    //Cach 2:
    return isConfirm
      ? dispatch(
          deleteItemCart({
            _id: id,
          })
        )
      : false;
  };
  return (
    <>
      {/*	Cart	*/}
      <div id="my-cart">
        <div className="row">
          <div className="cart-nav-item col-lg-7 col-md-7 col-sm-12">
            Thông tin sản phẩm
          </div>
          <div className="cart-nav-item col-lg-2 col-md-2 col-sm-12">
            Tùy chọn
          </div>
          <div className="cart-nav-item col-lg-3 col-md-3 col-sm-12">Giá</div>
        </div>
        <form method="post">
          {itemsCart?.map((item) => {
            return (
              <div className="cart-item row">
                <div className="cart-thumb col-lg-7 col-md-7 col-sm-12">
                  <img src={getImageProduct(item.thumbnail)} />
                  <h4>{item.name}</h4>
                </div>
                <div className="cart-quantity col-lg-2 col-md-2 col-sm-12">
                  <input
                    onChange={(e) => onChangeQty(e, item._id)}
                    type="number"
                    id="quantity"
                    className="form-control form-blue quantity"
                    value={item.qty}
                  />
                </div>
                <div className="cart-price col-lg-3 col-md-3 col-sm-12">
                  <b>
                    {Number(item.price * item.qty).toLocaleString("vi-VN")}đ
                  </b>
                  <a onClick={(e) => clickDeleteItemCart(e, item._id)} href="#">
                    Xóa
                  </a>
                </div>
              </div>
            );
          })}
          <div className="row">
            <div className="cart-thumb col-lg-7 col-md-7 col-sm-12" />
            <div className="cart-total col-lg-2 col-md-2 col-sm-12">
              <b>Tổng cộng:</b>
            </div>
            <div className="cart-price col-lg-3 col-md-3 col-sm-12">
              <b>{Number(totalPrice).toLocaleString("vi-VN")}đ</b>
            </div>
          </div>
        </form>
      </div>
      {/*	End Cart	*/}
      {/*	Customer Info	*/}
      <div id="customer">
        <div className="row">
          <div className="by-now col-lg-6 col-md-6 col-sm-12">
            {login.logged ? (
              <Link onClick={clickOrder} to="#">
                <b>Mua ngay</b>
                <span>Giao hàng tận nơi siêu tốc</span>
              </Link>
            ) : (
              <Link to="/Login">
                <b>Đăng nhập</b>
                <span>Đăng nhập để mua hàng</span>
              </Link>
            )}
          </div>
          <div className="by-now col-lg-6 col-md-6 col-sm-12">
            <a href="#">
              <b>Trả góp Online</b>
              <span>Vui lòng call (+84) 0988 550 553</span>
            </a>
          </div>
        </div>
      </div>
      {/*	End Customer Info	*/}
    </>
  );
};
export default Cart;
